import{filterUndefineds as e}from"./filterUndefineds.js";const r=(r,...t)=>{const n=e(t);if(n.length<=0)return r;return n.reduce(((e,r)=>(Object.keys(r).forEach((t=>{e[t]&&!r[t]||(e[t]=r[t])})),e)),r)};export{r as accumulate};
